import { Address } from '@/types'

const getBadgeVariantByStatus = (status?: string | boolean) => {
  if (typeof status === "boolean") {
    return status ? { isSuccess: true as const } : {};
  }

  if (typeof status !== "string") return {};
  
  const uppercasedStatus = status?.toUpperCase()

  switch (uppercasedStatus) {
    case 'SUCCEEDED':
    case 'ACTIVE':
    case 'VERIFIED':
    case 'OPEN':
    case 'GREEN':
      return { isSuccess: true as const }
    case 'REQUESTED':
    case 'NOT_VERIFIED':
    case 'YELLOW':
      return { isWarning: true as const }
    case 'IN_PROGRESS':
      return { isInfo: true as const }
    case 'FAILED':
      return { isDanger: true as const }
    default:
      return {}
  }
}

const getBadgeText = (status?: string | boolean) => {
  if (typeof status === "boolean") {
    return status ? "SUCCEEDED" : "unspecified";
  }

  if (typeof status !== "string" || !status.trim()) {
    return "unspecified";
  }

  return status.trim();
}

const toAddressString = (address?: Address): string => {
  if (!address) return 'Unspecified'

  const { address1, address2, city, zip, province, province_code, country, country_code } = address

  let addressString = `${address1}, `
  if (address2) {
    addressString += `${address2}, `
  }
  addressString += `${city}, `

  if (province && province_code) {
    addressString += `${province} (${province_code}), `
  } else if (province) {
    addressString += `${province}, `
  } else if (province_code) {
    addressString += `${province_code}, `
  }

  if (country) {
    addressString += `${country} (${country_code}) `
  } else {
    addressString += `${country_code} `
  }

  addressString += `- ${zip}`

  return addressString
}

const getVersion = (text?: string) => text?.match(/-([\w\d.]+)\.zip/)?.[1]

// Omit props from object
const omit = <T extends object>(value: T, keys: (keyof T)[]): Partial<T> => {
  const result = { ...value }
  keys.forEach((key) => {
    delete result[key]
  })
  return result
}

export { getBadgeVariantByStatus, toAddressString, getVersion, omit, getBadgeText }
